<template>
  <div class="account-view">
    <div class="heading-m semi-bold">{{ $t("account.settings") }}</div>

    <eg-b-tabs
      :value="activeTabIndex"
      class="account-settings-tabs"
      nav-wrapper-class="account-settings-tabs-nav"
      @input="onTabChange"
    >
      <eg-b-tab :title="$t('account.settings')">
        <div class="content">
          <account-settings />
        </div>
      </eg-b-tab>

      <eg-b-tab :title="$t('account.plansAndBilling')">
        <div class="content">
          <plans-billing />
        </div>
      </eg-b-tab>

      <eg-b-tab :title="$t('account.integrations')">
        <div class="content">
          <account-integrations-view />
        </div>
      </eg-b-tab>
      <eg-b-tab
        v-if="features.bulkImports"
        :title="$t('account.canvasSyncTasks')"
      >
        <div class="content">
          <canvas-sync-tasks-view />
        </div>
      </eg-b-tab>
    </eg-b-tabs>
  </div>
</template>

<script>
import AccountSettings from "./account_settings.vue";
import PlansBilling from "@/components/account/plans_billing.vue";
import AccountIntegrationsView from "@/views/account/integrations_view.vue";
import CanvasSyncTasksView from "@/views/sync_tasks_view.vue";
import { mapGetters } from "vuex";

export default {
  name: "AccountView",

  components: {
    AccountSettings,
    PlansBilling,
    AccountIntegrationsView,
    CanvasSyncTasksView,
  },

  inject: ["accountProvider", "refreshUsageIfNeeded"],

  data() {
    return {
      isSidebarOpen: false,
    };
  },

  computed: {
    ...mapGetters("config", ["features"]),

    litePlan() {
      return this.$store.getters.litePlan;
    },
    proPlan() {
      return this.$store.getters.proPlan;
    },
    premiumPlan() {
      return this.$store.getters.premiumPlan;
    },
    user() {
      return this.$store.state.user;
    },

    activeTabIndex() {
      const urlParams = new URLSearchParams(this.$route.query);
      const tabParam = urlParams.get("tab");

      const tabMapping = {
        subscription: 1,
        integrations: 2,
        syncTasks: 3,
      };

      return tabMapping[tabParam] || 0;
    },
  },

  async mounted() {
    await this.refreshUsageIfNeeded();
  },

  methods: {
    onTabChange(tabIndex) {
      const tabMapping = {
        0: "account",
        1: "subscription",
        2: "integrations",
        3: "syncTasks",
      };

      const tabName = tabMapping[tabIndex];
      if (tabName) {
        this.$router.push({
          path: "/account",
          query: tabName === "account" ? {} : { tab: tabName },
        });
      }
    },

    switchTab(tabName) {
      const tabMapping = {
        account: 0,
        subscription: 1,
        integrations: 2,
      };

      if (tabMapping[tabName] !== undefined) {
        this.$router.push({
          path: "/account",
          query: tabName === "account" ? {} : { tab: tabName },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  width: 170px;
}

@media (max-width: 768px) {
  .sidebar {
    display: none;
  }
}

.sidebar-button {
  border: 0;

  &.router-link-active {
    color: #fff;
    background-color: var(--info);
    border-color: var(--info);
  }
}

.content {
  width: 100%;
}

.account-view {
  font-family: Inter;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0 8px;
}
</style>

<style lang="scss">
.account-settings-tabs {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .nav-link:hover,
  .nav-link:focus {
    border-color: transparent !important;
    background-color: #f6f2ff;
  }
  .nav-link.active {
    border: none !important;
    color: #8a3ffc !important;
    border-bottom: 3px solid #8a3ffc !important;
    background-color: transparent !important;
  }
  .nav-link.active:hover,
  .nav-link.active:focus {
    border-bottom: 3px solid #8a3ffc !important;
  }
  .nav-link {
    color: var(--color-text-neutral-fade) !important;
  }
}
</style>
